import React, {useState} from 'react';
import __t from  '../lib/traduzioni';
import useBSSLogger from '../hooks/useBSSLogger';
const {logger} = useBSSLogger();
import { Typography } from "@mui/material";
import useFlashMessages, { raggruppaMessaggiPerTipo } from '../hooks/useFlashmessages';
import { Alert } from '@mui/material';

const FlashMessages = () => {
    
    const flashMessages = raggruppaMessaggiPerTipo(useFlashMessages());
    const tipi = Object.keys(flashMessages ?? {});

    return (
        <>
            {tipi.map((tipo, indiceTipo) => {

                return (
                    <Alert severity={tipo} key={indiceTipo}>
                        <ul>
                            {(flashMessages[tipo] ?? []).map((messaggio, indiceMessaggio) => {
                                return (
                                    <li key={indiceMessaggio}>
                                        {messaggio.messaggio}
                                    </li>
                                )
                            })}
                        </ul>
                    </Alert>
                )
            })}
        </>
    )
}

export default FlashMessages